export const NEW_SUBPATIENT_STRINGS = {
    PleaseTypeAName: 'Please type a name.',
    LegalGuardianError:
        'Please confirm whether you are the parent or legal guardian of the patient.',
    SexError: 'Please select a sex.',
};
